export const NAV_LINKS = [
  { label: "Услуги", href: "#services", testid: "nav-link-services" },
  { label: "За нас", href: "#about", testid: "nav-link-about" },
  { label: "Цени", href: "#pricing", testid: "nav-link-pricing" },
  { label: "Калкулатори", href: "#calculator", testid: "nav-link-calculator" },
  { label: "Статии", href: "#blog", testid: "nav-link-blog" },
  { label: "Въпроси", href: "#faq", testid: "nav-link-faq" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1631193816258-28b44b21e78b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwbW9kZXJuJTIwb2ZmaWNlJTIwYWNjb3VudGluZyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODg0NDg5MTh8MA&ixlib=rb-4.1.0&q=85",
  plovdiv: "https://images.unsplash.com/photo-1702795601280-b0abf0468cf0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxwbG92ZGl2JTIwY2l0eSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODg0NDg5MTh8MA&ixlib=rb-4.1.0&q=85",
  team: "https://images.unsplash.com/photo-1622675363311-3e1904dc1885?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBkaXZlcnNlJTIwdGVhbSUyMG9mZmljZSUyMG1lZXRpbmd8ZW58MHx8fHwxNzg4NDQ4OTE5fDA&ixlib=rb-4.1.0&q=85",
};

export const MARQUEE_WORDS = [
  "Направете правилната сметка",
  "Броим правилно от първия път",
  "Точност във всяка цифра",
  "Декларации навреме. Без изненади",
  "Спокойни пред НАП. Всеки месец",
  "Числата в ред",
  "Където сметката винаги излиза",
  "Do the right account",
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Прозрачност",
    text: "Прозрачни и ценово обосновани услуги. Винаги знаете какво плащате, защо го плащате и какво получавате в замяна — без скрити такси и изненади.",
  },
  {
    num: "02",
    title: "Прецизност",
    text: "Качествено счетоводно обслужване в срокове и в услуга на клиента — в пълно съответствие със Закона за счетоводството, ЗДДС и приложимите счетоводни стандарти.",
  },
  {
    num: "03",
    title: "Индивидуален подход",
    text: "Постоянна връзка с нашия екип и планиране на данъчните и осигурителните плащания според конкретния ви бизнес. Оптимизираме законно тежестта върху фирмата ви.",
  },
  {
    num: "04",
    title: "Партньорство",
    text: "Изграждаме дългосрочни и ползотворни отношения, които осигуряват спокойното развитие на вашата фирма. Пълна конфиденциалност на информацията — без компромис.",
  },
];

export const SERVICES = [
  {
    id: "abonament",
    title: "Абонаментно счетоводно обслужване",
    short: "Цялостна защита на интересите на фирмата ви пред всички институции.",
    text: "Хронологично, синтетично и аналитично отчитане на дейността, ежемесечни справки по ЗДДС, ведомости за заплати, Интрастат, годишен счетоводен отчет и годишна данъчна декларация по ЗКПО. Постоянни консултации с нашите специалисти и следене на разчетите с клиенти и доставчици.",
    span: "md:col-span-4",
  },
  {
    id: "godishno",
    title: "Годишно счетоводно приключване",
    short: "Всички законови изисквания за администриране на фирмата след края на годината.",
    text: "Годишен финансов отчет, годишна данъчна декларация по ЗКПО, справки за НСИ и публикуване в Търговския регистър — идеално за фирми без дейност или без текущо счетоводство.",
    span: "md:col-span-2",
  },
  {
    id: "otcheti",
    title: "Съставяне на финансови отчети",
    short: "Съставяне, проверка и заверяване на годишни финансови отчети.",
    text: "Квалифициран счетоводител по изискванията на Закона за счетоводството съставя и заверява или проверява и заверява финансовите отчети на вашето дружество.",
    span: "md:col-span-2",
  },
  {
    id: "zaplati",
    title: "Труд и работна заплата (ТРЗ)",
    short: "Цялостно администриране на личния състав и заплатите — срещу цена, по-ниска от нова заплата.",
    text: "Трудови договори и регистрация в НОИ, досиета и длъжностни характеристики, ведомости и платежни нареждания, Декларации 1 и 6, болнични листове и пълна кореспонденция с институциите.",
    span: "md:col-span-4",
  },
  {
    id: "registracia",
    title: "Регистриране на фирми",
    short: "От избора на правна форма до вписването в Търговския регистър — за дни, не за седмици.",
    text: "Регистрация на ЕООД, ООД и ЕТ, подготовка на учредителни документи, вписване в Агенцията по вписванията, регистрация по ЗДДС и първоначална счетоводна настройка на новата фирма.",
    span: "md:col-span-2",
  },
  {
    id: "konsultacii",
    title: "Данъчни и трудови консултации",
    short: "Ясни отговори защо плащате и къде отиват парите, които превеждате на държавата.",
    text: "Консултации в сферата на данъчното, трудовото и осигурителното законодателство — за стартиране, разширяване или законна оптимизация на данъци, заплати и осигуровки.",
    span: "md:col-span-2",
  },
  {
    id: "cta",
    title: "Не намирате услугата си?",
    short: "Свържете се с нас — ще предложим решение за вашия случай.",
    text: "",
    span: "md:col-span-2",
    isCta: true,
  },
];

export const PRICING = [
  {
    id: "start",
    name: "Старт",
    price: "от 90 €",
    period: "/ месец",
    desc: "За стартиращи фирми и свободни професии.",
    features: [
      "До 20 първични документа месечно",
      "Текущо счетоводно отчитане",
      "Ежемесечни справки по ЗДДС",
      "Годишно счетоводно приключване",
      "Консултации по имейл",
    ],
    featured: false,
    testid: "pricing-card-start",
  },
  {
    id: "biznes",
    name: "Бизнес",
    price: "от 240 €",
    period: "/ месец",
    desc: "За активни фирми с персонал и оборот.",
    features: [
      "До 60 първични документа месечно",
      "Всичко от пакет „Старт“",
      "Личен състав и заплати до 5 служителя",
      "Декларации 1 и 6 към НОИ",
      "Приоритетни консултации",
    ],
    featured: true,
    testid: "pricing-card-biznes",
  },
  {
    id: "korporativ",
    name: "Корпоративен",
    price: "по договаряне",
    period: "",
    desc: "За по-големи структури и специфични изисквания.",
    features: [
      "Неограничен обем документи",
      "Персонален екип от специалисти",
      "Данъчно планиране и оптимизация",
      "Интрастат и вътреобщностни сделки",
      "Отчети за мениджмънта",
    ],
    featured: false,
    testid: "pricing-card-korporativ",
  },
];

export const TESTIMONIALS = [
  {
    quote: "Работим с RightAccount от три години. Всичко е в срок, а консултациите ни спестиха реални разходи за данъци.",
    name: "Иван Петров",
    role: "Управител, „Петров Трейд“ ЕООД",
  },
  {
    quote: "Прецизност и спокойствие. Годишното приключване мина без една забележка от страна на НАП.",
    name: "Мария Георгиева",
    role: "Собственик, „Ателие МГ“",
  },
  {
    quote: "Поеха личния състав и заплатите изцяло. Най-накрая имаме време да мислим за бизнеса, а не за документи.",
    name: "Георги Димитров",
    role: "„Димитров Логистик“ ООД",
  },
];

export const FAQS = [
  {
    q: "Колко струва абонаментното счетоводно обслужване?",
    a: "Цената зависи основно от обема на първичните документи и броя на служителите. Ориентировъчно стартираме от 90 € месечно. След кратка безплатна консултация изготвяме точна и фиксирана оферта.",
  },
  {
    q: "Какви документи трябва да изпращам всеки месец?",
    a: "Издадени и получени фактури, касови бележки, банкови извлечения и документи за разходи — до 5-то число на следващия месец. Приемаме документи онлайн, лично или чрез куриер.",
  },
  {
    q: "Можете ли да поемете фирма със задължения или пропуски към НАП?",
    a: "Да. Започваме с пълен преглед на счетоводното състояние и задълженията, след което предлагаме план за изравняване и коректно администриране занапред.",
  },
  {
    q: "Работите ли с фирми извън Пловдив?",
    a: "Да — обслужваме клиенти от цялата страна изцяло дистанционно. Документите се обменят онлайн или по куриер, а консултациите се провеждат по телефон или видео връзка.",
  },
  {
    q: "Какво включва годишното счетоводно приключване?",
    a: "Изготвяне на годишен финансов отчет по ЗСч и приложимите стандарти, годишна данъчна декларация по ЗКПО, справки за НСИ и публикуване на отчета в Търговския регистър.",
  },
  {
    q: "Как се сменя счетоводна къща?",
    a: "Ние поемаме цялата комуникация с досегашния ви счетоводител, прехвърляме архива и продължаваме отчитането без прекъсване и без загуба на информация.",
  },
  {
    q: "Колко време отнема регистрирането на фирма?",
    a: "При готови документи вписването на ЕООД или ООД в Търговския регистър отнема обикновено 2–4 работни дни. Подготвяме учредителните документи, подаваме заявлението и при нужда извършваме регистрация по ЗДДС, така че фирмата ви да стартира с коректно счетоводство от първия ден.",
  },
];

export const ARTICLES = [
  {
    id: "godishno-priklyuchvane",
    title: "Годишното счетоводно приключване: срокове и документи",
    excerpt: "Кои декларации се подават, до кога и какво рискувате при закъснение.",
    date: "12 февруари 2026",
    readTime: "5 мин",
    body: [
      "Всяко дружество в България — дори и такова без дейност — е длъжно да изготви годишен финансов отчет и да подаде годишна данъчна декларация по Закона за корпоративното подоходно облагане. Пропускането на сроковете води до имуществени санкции и ненужно внимание от страна на НАП.",
      "Годишната данъчна декларация се подава в срок от 1 март до 30 юни на следващата година, а финансовият отчет се публикува в Търговския регистър. Към тях се прилагат и справки за Националния статистически институт.",
      "Най-честата грешка при фирмите без текущ счетоводител е да изчакват последния момент. Препоръката ни е документите да се съберат още през януари — така остава време за проверки и корекции.",
      "Ако фирмата ви не е развивала дейност, не е регистрирана по ЗДДС и няма персонал, услугата „Годишно счетоводно приключване“ покрива всички законови изисквания с еднократно ангажиране на счетоводител.",
    ],
  },
  {
    id: "dds-registracia",
    title: "Регистрация по ЗДДС: кога е задължителна и кога е изгодна",
    excerpt: "Прагове, срокове и практически съвети преди да подадете заявление.",
    date: "28 януари 2026",
    readTime: "6 мин",
    body: [
      "Регистрацията по Закона за данък върху добавената стойност става задължителна при достигане на определен облагаем оборот за период от 12 последователни месеца. Актуалният праг се променя със законодателни решения, затова винаги го уточнявайте при консултация със счетоводител.",
      "Има и доброволна регистрация — тя е изгодна, когато работите основно с регистрирани по ДДС клиенти и имате значителни разходи с данъчен кредит, например при стартови инвестиции.",
      "Регистрацията носи и задължения: ежемесечни справки-декларации, дневници за покупки и продажби и издаване на фактури по реда на ЗДДС. Неспазването на сроковете води до санкции дори при нулев резултат.",
      "Нашият съвет: преди регистрация направете кратка симулация на паричните си потоци. Понякога изчакването с няколко месеца е финансово по-разумното решение.",
    ],
  },
  {
    id: "trudovi-dogovori",
    title: "Трудови договори и Декларации 1 и 6 накратко",
    excerpt: "Какво трябва да знае всеки работодател преди да назначи първия си служител.",
    date: "9 януари 2026",
    readTime: "4 мин",
    body: [
      "Сключването на трудов договор е съпроводено със задължително уведомление към НАП в тридневен срок от сключването му и преди започване на работа. Това е една от най-често санкционираните пропуски при нови работодатели.",
      "Декларация образец 1 се подава за всеки осигурен служител с данни за осигурителния доход и вноските, а Декларация образец 6 обобщава дължимите данъци и осигуровки от работодателя. И двете имат стриктни месечни срокове.",
      "Освен това работодателят води досие на всеки служител, издава заповеди за отпуски, носи болнични листове до НОИ и съхранява трудовата документация с години назад.",
      "Услугата „Личен състав и работни заплати“ поема всичко това изцяло — на цена, значително по-ниска от назначаването на отделен специалист.",
    ],
  },
];

export const CONTACTS = {
  address: "гр. Пловдив, бул. „Дунав“ 196А, офис 7",
  phone: "+359 887 198 420",
  email: "rightaccount@abv.bg",
  hours: "Понеделник – Петък, 9:00 – 18:00",
};

export const SOCIALS = [
  { id: "facebook", label: "Facebook", url: "https://www.facebook.com/", testid: "social-facebook" },
  { id: "linkedin", label: "LinkedIn", url: "https://www.linkedin.com/", testid: "social-linkedin" },
  { id: "instagram", label: "Instagram", url: "https://www.instagram.com/rightaccount1", testid: "social-instagram" },
];

export const GOOGLE_REVIEW = {
  rating: 5.0,
  count: 24,
  url: "https://share.google/OLl6pa6Y4XxwY6opS",
};

export const SERVICE_OPTIONS = [
  "Абонаментно счетоводно обслужване",
  "Регистриране на фирми",
  "Годишно счетоводно приключване",
  "Съставяне на финансови отчети",
  "Труд и работна заплата (ТРЗ)",
  "Данъчни консултации",
  "Трудови консултации",
  "Друго",
];

export const SEO_KEYWORDS = [
  "Счетоводство",
  "Счетоводна къща",
  "Счетоводни услуги",
  "Регистриране на фирми",
  "Труд и работна заплата",
  "Данъчни консултации",
  "Трудови консултации",
  "Кантора Пловдив",
];
